import { SortingState } from "@tanstack/react-table";
import isEmpty from "lodash/isEmpty";
import { ImportHistoryPage } from "PFApp/components/import_modal/components/import_history_page";
import { parseSorting } from "PFApp/components/import_modal/components/import_history_page/parts/imports_history_table/helpers";
import { useUsersImports } from "PFCore/hooks/queries/users";
import { BulkOperationsState } from "PFCore/services/bulk_operations";
import { UsersImport } from "PFCore/services/users/import";
import { useCallback, useState } from "react";

export const ImportUsersHistory = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [sorting, setSorting] = useState<SortingState>();

  const { data, isLoading } = useUsersImports({
    page: currentPage,
    perPage: 10,
    order: sorting && !isEmpty(sorting) ? parseSorting(sorting) : null
  });

  const handleSortingChange = (newSorting: SortingState) => {
    setSorting(newSorting);
    setCurrentPage(1);
  };

  const isDetailsEnabled = useCallback(
    (row: UsersImport) =>
      row.state === BulkOperationsState.Completed ||
      row.state === BulkOperationsState.PartiallyCompleted ||
      row.state === BulkOperationsState.Failed,
    []
  );

  return (
    <ImportHistoryPage<UsersImport>
      currentPage={currentPage}
      onCurrentPageChange={setCurrentPage}
      totalPages={data?.meta.totalPages || 1}
      sorting={sorting}
      onSortingChange={handleSortingChange}
      data={data?.entries}
      isLoading={isLoading}
      isDetailsEnabled={isDetailsEnabled}
      displayFileErrorsColumn={false}
    />
  );
};
